<template>
  <div class="detailInfo">
    <!-- 面包屑 -->
    <bread-crumb>
      <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'TongZhiGongGao' }"
        >通知公告</el-breadcrumb-item
      >
      <el-breadcrumb-item>详情</el-breadcrumb-item>
    </bread-crumb>
    <div class="infoBox">
      <div class="titBox">
        <div class="tit">{{ detail.Title }}</div>
        <div class="time">发布时间：{{ detail.AddDate }}</div>
      </div>
      <div class="contBox"  ref="contHtml" v-html="detail.InforContent"></div>
      <div v-if="files.length > 0" class="file-box">
        附件：<label v-for="item in files" :key="item.FileName"
          ><a style="color:#000" target="bank" :href="item.VirtualPath">{{
            item.FileName
          }}</a></label
        >
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
import { getInforDetail } from "@/api/index.js";
export default {
  name: "DetailInfo",
  data() {
    return {
      detail: "",
      files: [],
    };
  },
  created(){
    this.getDetail()
  },
  updated() {
    let doms = this.$refs.contHtml.childNodes;
    doms.forEach(element => {
      element.style.fontSize = '20px';
      element.style.fontFamily = '仿宋';
    });
 },
  methods: {
    getDetail() {
      let unitguid = this.$route.query.unitguid;
      let data = {
        UnitGuid: unitguid,
        TenantID: this.$store.state.tenantid,
      };
      getInforDetail(data).then((res) => {
        if (res) {
          this.detail = res.message ? res.message[0] : "";
          this.detail.InforContent = this.detail.InforContent.replace(/src="\/Cloud\/ReadAlOSS.aspx/g,`src="${this.$store.state.baseImgUrl}/Cloud/ReadAlOSS.aspx`)
          this.detail.FileList = this.detail.FileList ? JSON.parse(this.detail.FileList) : [];
          this.getFiles();
        }
      });
    },
    getFiles() {
      let baseURL = request.defaults.baseURL;
      this.files = this.detail.FileList.map((element) => {
        element.VirtualPath = baseURL + element.VirtualPath;
        return element;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.detailInfo {
  min-height: calc(100vh - 406px);
  .infoBox {
    width: 1200px;
    margin: 0 auto;
    .titBox {
      border-bottom: 1px solid $border-color-EBEBEB;
      text-align: center;
      padding: 26px 0 16px 0;
      .tit {
        font-size: $fonts-24;
        font-weight: 600;
        letter-spacing: 1px;
      }
      .time {
        color: $color-9;
        padding-top: 20px;
      }
    }
    .contBox {
      padding: 12px 0;
    }
    .file-box{
      height: 40px;
      label{
        border: 1px solid #f5f5f5;
        border-radius: 6px;
        padding: 8px 20px;
        margin-right: 10px;
        background-color: #f5f5f5;
      }
    }
  }
}
</style>
